import { render, staticRenderFns } from "./footprint.vue?vue&type=template&id=5e7633f0&scoped=true&"
import script from "./footprint.vue?vue&type=script&lang=js&"
export * from "./footprint.vue?vue&type=script&lang=js&"
import style0 from "./footprint.vue?vue&type=style&index=0&id=5e7633f0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7633f0",
  null
  
)

export default component.exports